import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Link, { LinkProps } from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import UserUtils from '../../utils/userUtils';
import styles from './mylink-style';
import { getMenu } from '../menu-drawer/menu-drawer';

interface MyLinkProps extends LinkProps {
    to: string;
    color?: 'initial' | 'inherit' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error';
}

const MyLink: React.FC<MyLinkProps> = (props): JSX.Element => {
    const { children, to, color, ...rest } = props;

    const isUrlAllowed = (url): boolean => {
        const urls = getMenu(() => {}).map((m) => m.to);
        if (UserUtils.isAdmin()) {
            return true;
        } else {
            for (let i = 0; i < urls.length; i++) {
                const u = urls[i];
                if ((u === '/' && url === '/') || (u !== '/' && url.startsWith(u))) {
                    return true;
                }
            }
            return false;
        }
    };

    const urlAllowed: boolean = isUrlAllowed(to);

    return (
        <>
            {urlAllowed ? (
                <Link {...rest} color={color ? color : 'secondary'} component={RouterLink} to={to}>
                    {children}
                </Link>
            ) : (
                children
            )}
        </>
    );
};

export default withStyles(styles)(MyLink);
